export default __webpack_public_path__ + "static/media/vf1.084201a8.jpg";